import * as React from "react";
const SvgFiRrMartiniGlassCitrus = (props) => (
  <svg
    xmlns="http://www.w3.org/2000/svg"
    fill="none"
    viewBox="0 0 24 24"
    {...props}
  >
    <g clipPath="url(#fi-rr-martini-glass-citrus_svg__a)">
      <path
        fill="#062147"
        d="M18 0a5.98 5.98 0 0 0-5.659 4H2.765A2.75 2.75 0 0 0 .192 5.771c-.41 1.045-.16 2.161.676 2.934l6.668 6.16c.434.395.936.667 1.465.818V22h-3a1 1 0 1 0 0 2h8a1 1 0 1 0 0-2h-3v-6.318a3.7 3.7 0 0 0 1.471-.823l3.483-3.218a6.006 6.006 0 0 0 8.046-5.642 6.006 6.006 0 0 0-6-5.999m-6.88 13.386c-.638.581-1.6.58-2.233.005L2.2 7.214c-.27-.251-.208-.555-.146-.713.095-.242.331-.501.711-.501h14.471c.38 0 .616.259.711.501a.63.63 0 0 1-.17.735zM18 10q-.13 0-.26-.009l1.418-1.31c.811-.75 1.061-1.865.65-2.91A2.755 2.755 0 0 0 17.235 4h-2.703A4.004 4.004 0 0 1 22 6c0 2.206-1.794 4-4 4"
      />
    </g>
    <defs>
      <clipPath id="fi-rr-martini-glass-citrus_svg__a">
        <path fill="#fff" d="M0 0h24v24H0z" />
      </clipPath>
    </defs>
  </svg>
);
export default SvgFiRrMartiniGlassCitrus;
